export default __webpack_public_path__ + "static/media/Grand Elder Jerkin.deacf639.jpg";